import Vue from 'vue'
import Vuex from 'vuex'

import * as actions from "./actions";
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // url: "http://clinica-back-asistencial.test/api/v2", // local
    url: "https://bmback.v2.howertpi.com/api/v2", // nube   //demo-dr-back.howertpi.com
    urlV3: "http://clinica-back-asistencial.test/api/v3", // local
    // urlV3:"https://demo-dr-back.howertpi.com/api/v3", // nube
    token: null,
    /** auth */
    user: {
      id: null,
      name: null,
      email: null,
      last_name: null,
      document_type: null,
      dni: null,
      password: null,
      rol_id: null,
      //campu_id: null,
      // departure_id: null,
      state: null,
      roles: [],
      permissions: [],
    },
    dataCampus: [],
    campus: null,
    patientData: {
      clinical_historie_id: null,
      medical_act_id: null,
      patient_id: null
    }
  },
  getters: {
    get__url(state) {
      return state.url;
    },
    get__url_v3(state) {
      return state.urlV3;
    },
    get__token(state) {
      return state.user.token;
    },
    get__user(state) {
      return state.user;
    },
    get__campus(state) {
      return state.campus;
    },
    get__datacampus(state) {
      return state.dataCampus;
    },
    get__patient_data(state) {
      return state.patientData;
    }
  },
  mutations: {
    /** auth */
    mt_set_auth(state, payload) {
      state.user = payload;
    },
    mt_set_refresh(state, user) {
      state.user = user;
    },
    mt_logout_auth(state) {
      state.user = {
        id: null,
        name: null,
        email: null,
        last_name: null,
        document_type: null,
        dni: null,
        password: null,
        rol_id: null,
        //campu_id: null,
        // departure_id: null,
        state: null,
        roles: [],
        permissions: [],
      };
    },
    mt_set_datacampus(state, payload) {
      state.dataCampus = payload;
    },
    mt_set_campus(state, payload) {
      state.campus = payload;
    },
    mt_set_patient_data(state, payload) {
      state.patientData = payload;
    },
    mt_clear_patient_data(state) {
      state.patientData = {
        clinical_historie_id: null,
        medical_act_id: null,
        patient_id: null
      };
    }
  },
  actions,
  modules: {
  },
  plugins: [
    createPersistedState({
      reducer: (persistedState) => {
        const stateFilter = JSON.parse(JSON.stringify(persistedState));
        return stateFilter;
      }
    })
  ]
})
